import countries from 'i18n-iso-countries';
import english from 'i18n-iso-countries/langs/en.json';
import portuguese from 'i18n-iso-countries/langs/pt.json';

// languages supported
countries.registerLocale(english);
countries.registerLocale(portuguese);

export type SupportedLocale = 'en' | 'pt';

// update if new languages added
export const supportedLanguages = ['en', 'pt'];

export const getCountryTranslations = (
    country: string,
    locale: SupportedLocale,
) => {
    const localeToUse = supportedLanguages.includes(locale) ? locale : 'en';
    return countries.getName(country, localeToUse);
};
